/**
 * WordPress dependencies
 */

import { __ } from '@wordpress/i18n';
import { Icon,DropdownMenu,MenuItemsChoice } from '@wordpress/components';
import { mobile, tablet, desktop } from '@wordpress/icons';
import { useSelect, useRegistry  } from '@wordpress/data';
import { store as editorStore } from '@wordpress/editor';
import {useState } from '@wordpress/element';

 const VayuBlocksDevice = () => {
    //const registry = useRegistry();
	const getView = useSelect( ( select ) => {
		return select( editorStore ).getDeviceType();
	}, [] );

    return getView;
}


const VayuBlocksDeviceControl = ({ label,classname='normal'}) => {
    const deviceName = VayuBlocksDevice();

    const handelClickDevice = (device) =>{
       wp.data.dispatch('core/editor').setDeviceType(device);
    }
    
    const deviceIon = (dicon) => {
        const icons = {
            Tablet: tablet,
            Mobile: mobile,
            Desktop: desktop,
        };
    
        return <Icon icon={icons[dicon] || desktop} />;
    }
    

    return (<div className="device-setting-vb">
                <DropdownMenu label="View" icon={deviceIon(deviceName)}>
                    { ( { onClose } ) => ( <MenuItemsChoice
                    choices={[
                    {
                        label: __('Desktop','vayu-blocks'),
                        value: 'Desktop'
                    },
                    {
                        label:  __('Tablet','vayu-blocks'),
                        value: 'Tablet'
                    },
                    {
                        label:  __('Mobile','vayu-blocks'),
                        value: 'Mobile'
                    }
                    ]}
                    onSelect={ ( newDevice ) => handelClickDevice( newDevice ) }
                    value={deviceName}
                    />
                    ) }
                </DropdownMenu>
                {label && (<label className={classname}>{label}</label>)}
               
            </div>
    );
};


export {VayuBlocksDevice,VayuBlocksDeviceControl};

